import ApiService from "./api.service";

const TipoLogradouro = {
  async getTipos(params) {
    return await ApiService.get("/tipo-logradouro", params);
  },
};

export default TipoLogradouro;
